"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_tippy_1 = require("react-tippy");
var tooltip = function (props) {
    return (react_1.default.createElement(react_tippy_1.Tooltip, { title: props.title, trigger: props.trigger, open: props.open, position: props.position, arrow: props.arrow, animation: props.animation, unmountHTMLWhenHide: true, sticky: true, stickyDuration: 0, distance: props.distance, style: { display: "inline-block" } }, props.children));
};
exports.default = tooltip;
//# sourceMappingURL=index.js.map